import { tokens } from 'ComponentLibrary'
import type { ContentChipColor } from 'ComponentLibrary/src/piazza/content/ContentChip/ContentChip'

export type ValueCheckResultColorInput = {
    confirmed?: boolean
    delta_market_value?: number | null
}

export type ValueCheckResultColorVariant = 'negative' | 'warning' | 'positive' | 'neutral'

const getValueCheckResultColorVariant = (valueCheck: ValueCheckResultColorInput): ValueCheckResultColorVariant => {
    if (!valueCheck.confirmed) {
        return 'negative'
    }
    if (valueCheck.delta_market_value !== undefined && valueCheck.delta_market_value !== null) {
        return valueCheck.delta_market_value < 0 ? 'warning' : 'positive'
    }
    return 'neutral'
}

export const getValueCheckResultTextColor = (valueCheck: ValueCheckResultColorInput): string | undefined => {
    const variant = getValueCheckResultColorVariant(valueCheck)
    switch (variant) {
        case 'negative':
            return tokens.ColorTextDangerSubtle
        case 'warning':
            return tokens.ColorTextWarningSubtle
        case 'positive':
            return tokens.ColorTextPositiveSubtle
        case 'neutral':
            return undefined
    }
}

export const getValueCheckResultChipColor = (valueCheck: ValueCheckResultColorInput): ContentChipColor => {
    const variant = getValueCheckResultColorVariant(valueCheck)
    switch (variant) {
        case 'negative':
            return 'red'
        case 'warning':
            return 'orange'
        case 'positive':
            return 'green'
        case 'neutral':
            return 'blue'
    }
}
